// Use the same option record for top-level and nested dropdown answers.
let lastOptionId = 0;

export const createDropdownOption = () => {
  lastOptionId = Math.max(Date.now(), lastOptionId + 1);
  return {
    id: lastOptionId,
    label: '',
    value: '',
    remark: '',
    showInAssessment: false,
    answerText: '',
    attachOrders: false,
    suggestDiagnosis: false,
    diagnosis: null,
    orders: null,
    providerInstruction: '',
    linkedQuestion: null,
    linkedAssessment: null,
  };
};
